import React, {Component, useEffect, useState} from 'react';

import {ProjectService} from 'config/services/project.service';

import styles from './styles.module.scss';

import money from '~assets/money.png';
import projects from '~assets/projects.png';
import {useEvent} from "ra-core";
import {useLocation} from "react-router-dom";
import {useParams} from "react-router";
import i18next from 'i18next';

const ProjectsData = (props) => {
    const [state, setState] = useState({
        totalCount: 0,
        totalInvestment: 0
    });
    const location = useLocation();
    const {id} = useParams();

    const projectService = new ProjectService();


    useEffect(() => {
        getData();
    }, [location.search]);

    const getData = () =>
    {
        // eslint-disable-next-line react/prop-types
        const query = location.search.substring(1);
        const vars = query.split('&');
        let filterObj = {};
        for (let i = 0; i < vars.length; i++) {
            const pair = vars[i].split('=');
            if (pair[0] === 'filter') {
                filterObj = JSON.parse(decodeURIComponent(pair[1]));
            }
        }
        let filterQuery = '';
        // eslint-disable-next-line guard-for-in
        for (const key in filterObj) {
            const filterData = filterObj[key];
            if (typeof filterData === 'object' && !Array.isArray(filterData)) {
                for (const filterDataKey in filterData) {
                    filterQuery = `${filterQuery}${key}[${filterDataKey}]=${filterObj[key][filterDataKey]}&`;
                }
            } else {
                filterQuery = `${filterQuery}${key}=${filterObj[key]}&`;
            }
        }
        if (filterQuery) {
            filterQuery = `?${filterQuery.substring(0, filterQuery.length - 1)}`;
            if (id) {
                filterQuery = `${filterQuery}&route_id=${id}`;
            }
        }
        else {
            if (id) {
                filterQuery = `?route_id=${id}`;
            }
        }

        projectService
            .get_projects_list_extra_data(filterQuery)
            .then(res => {
                setState(res.data);
            })
            .catch(() => {
                setState({});
            });
    }

    return (
        <div className={styles.breadcrumbContainer}>
            <div className={styles.breadcrumbItem}>
                <div className={styles.breadcrumbItemIcon}>
                    <img src={projects} alt="projects"/>
                </div>
                <div className={styles.breadcrumbItemTitle}>
                    {i18next.t('projects-iirsa:totalProjects')}
                </div>
                <div className={styles.breadcrumbItemValue}>
                    {state.totalCount || 0}
                </div>
            </div>
            <div className={styles.breadcrumbItem}>
                <div className={styles.breadcrumbItemIcon}>
                    <img src={money} alt="money"/>
                </div>
                <div className={styles.breadcrumbItemTitle}>
                    {i18next.t('projects-iirsa:totalInvestmentLabel')}
                </div>
                <div className={styles.breadcrumbItemValue}>
                    {state.totalInvestment || 0}
                </div>
            </div>
        </div>
    );
}

export default ProjectsData;
